/*
M. Malits: Bürgereeinstieg in 2 Modi.
BE= Burgenland energie
Buerger= für Bürgereinstieg Land burgenland
 */

const mode: string = "BUERGER";//BurgenlandEndergie
//const mode="BE";//BurgenlandEndergie
const const_modebe = "BE"
const constmodebuer = "BUERGER";
import React, {Component, ReactComponentElement, ReactElement, useEffect, useState} from 'react';
import gutebreitband from './Gute_Breitbandversorgung.jpg'
import mittlerebreitband from './MIttlere_Breitbandversorgung.jpg'
import schlechtebreitband from './Schlechte_Breitbandversorgung.jpg'
import anbieteranzahl from './Anbieteranzahl.jpg'
import aktausbau from './AktuellerAusbau.jpg'
import zukausbau from './Zukuenftig_Breitbandausbau.jpg'
import infobutton from './Info_Button.png'
import './App.css'

import Switch from "react-switch";
import ReactSwitch from "./ReactSwitch";
import ReactDropDown from "./ReactSwitch";
import InputSelectString, {Foerdernehmertype, SelectTypeString} from "./ReactDropDown";
import MapControl from './MapControl';
import {
    ApplyTheme,
    myInit,
    SearchAnbieter,
    SearchFoerderprojekte,
    SearchGemeinden,
    Testlogin,
    ZoomExtent
} from "./TestMap";
import {ActionMeta, OnChangeValue} from "react-select";
import ReactAnbieter from "./ReactAnbieter";
import ReactFoerder from "./ReactFoerder";
import ReactLoaderSpinner from './ReactLoaderSpinner';
import ReactGemeindeText from "./ReactGemeindeText";


function App() {

    let extents: { name: string, window: Number[] }[]
    const [gemeindeoptions, setGemeindeoptions] = React.useState<SelectTypeString[]>([]);
    const [aktgemeinde, setAktGemeinde] = React.useState<string>("");
    const [isaktausbauactive, setIsaktausbauactive] = React.useState<boolean>(false);
    const [isanbieter, setIsanbieter] = React.useState<boolean>(false);
    const [isbreitbandactive, setIsbreitbandactive] = React.useState<boolean>(false);
    const [iszukausbauactive, setIszukausbauactive] = React.useState<boolean>(false);
    const [isAusbauActive, setIsAusbauActive] = React.useState<boolean>(false);
    const [anbieter, setAnbieter] = React.useState<string[]>([]);
    const [foerderungen, setFoerdernehmer] = React.useState<Foerdernehmertype[]>([]);
    const [isLoading, setLoading] = React.useState<boolean>(true);
    let defaultoption: SelectTypeString = {value: 'Keine', label: 'Bitte wählen sie eine Gemeinde aus', extent: []};
    const [cssClass, setCssClass] = useState(mode);
    //Todo: Wird dann nur einmal ausgeführt.

    useEffect(() => {

        setLoading(true);
        Testlogin().then(function (data) {

            myInit(mode);
            SearchGemeinden().then(function (data) {
                let options: SelectTypeString[] = [];
                data.forEach(function (element: any) {
                        let str: number[] = [];
                        element.extent.trimStart().split(' ').forEach((el: string) => str.push(Number(el)));
                        options.push({value: element.assetid, label: element.name, extent: str});


                    }
                );
                setGemeindeoptions(options);
                setLoading(false);
            }).catch(function (err) {
                // Run this when promise was rejected via reject()
                console.log(err)
            });
        }).catch(function (err) {
            // Run this when promise was rejected via reject()
            console.log(err)
        });
    }, []);
    let content = <ReactLoaderSpinner></ReactLoaderSpinner>;

    if (!isLoading) {
        content = <div className={"AppCenter"}>
            <div className={"AppContent"}>
                <div style={{display: "flex", justifyContent: "left"}}>
                    <InputSelectString selectedOptoin={defaultoption}
                                       possibleOptions={gemeindeoptions}
                                       mode={mode}
                                       saveChanges={HandleGemeindeChange}></InputSelectString>
                </div>
                <div className={ApplyClassName("map-wrapper")}>
                    <div>
                        <div id="myMap" style={{width: "700px"}}></div>
                    </div>

                    <div style={{marginRight: "10px"}}>
                        <text className={ApplyClassName("detailHeading")}>Festnetzversorgung</text>
                        <br/><br/>
                        <div className="legend">
                            <img title={"Test"} className="legendicon" src={gutebreitband}></img>
                            <text className="legendtext legendtextgut"> &ensp;{mode==const_modebe?"Bereits ausgebaut":  "Sehr gute Versorgung"}&ensp; </text>
                            <img title={">=100Mbit/s"} className="infoicion" src={infobutton}></img>

                        </div>
                    {mode != const_modebe &&<div className="legend">

                            <img title={"Test"} className="legendicon" src={mittlerebreitband}></img>
                            <text className="legendtext legendtextmittel">Gute Versorgung&ensp;</text>
                            <img title={">=30Mbit/s und <100Mbit/s"} className="infoicion" src={infobutton}></img>
                            <text className="legendbandwith"></text>
                        </div>}
                {mode != const_modebe &&<div className="legend">
                            <img title={"Test"} className="legendicon" src={schlechtebreitband}></img>
                            <text className="legendtext legendtextschlecht">&ensp;Versorgung &ensp;</text>
                            <img title={"<30Mbit/s"} className="infoicion" src={infobutton}></img>
                        </div>}

                        {/*
                        <div className="legend">
                            <img title={"Test"} className="legendicon" src={anbieteranzahl}></img>
                            <text className="legendtext">&ensp;Anbieteranzahl</text>
                        </div>*/
                        }
                        <div className="legend">
                            <img title={"Test"} className="legendicon" src={aktausbau}></img>
                            <text className="legendtext">&ensp;Aktueller Ausbau&ensp;
                                <img
                                    title={"Geförderte Projekte welche im Zuge von BBA2020 und BBA2030 derzeit realisiert werden"}
                                    className="infoicion" src={infobutton}></img>
                            </text>
                            {/*<img title={"<30Mbit/s"} className="infoicion" src={infobutton}></img>*/}
                        </div>
                        {mode != const_modebe &&<div className="legend">
                            <img title={"Test"} className="legendicon" src={zukausbau}></img>
                            <text className="legendtext">&ensp;Potentieller Ausbau&ensp;</text>
                            <img
                                title={"Gebiete in denen ein geförderter Ausbau im Rahmen einer zukünftigen Ausschreibung möglich wäre"}
                                className="infoicion" src={infobutton}></img>
                        </div>}
                        <br/>
                        <ReactGemeindeText gemeinde={aktgemeinde}></ReactGemeindeText>
                        {mode != const_modebe && <div className="detailContainer">
                            <text className="detailHeading">Anbieter</text>
                            <ReactAnbieter anbieter={anbieter}></ReactAnbieter>
                        </div>}

                        {/*!!foerderungen.length && */<div className="detailContainer">
                            <text className="detailHeading">Geförderte Ausbauprojekte</text>
                            <ReactFoerder foerderungen={foerderungen}></ReactFoerder>
                        </div>
                        }

                    </div>
                </div>

                <div>
                    <table>
                        <tbody>
                        <tr>
                            <td><ReactSwitch title={mode == const_modebe? 'Breitbandversorgung BET' :'Breitbandversorgung'} layername='Bandbreiten' checked={true}
                                             applylayerchange={HandlyLayerChange}> Test</ReactSwitch></td>
                            {mode != const_modebe &&
                                <td><ReactSwitch title='Anbieteranzahl' layername='Anbieter' checked={false}
                                                 applylayerchange={HandlyLayerChange}> Test</ReactSwitch></td>}
                        </tr>
                        <tr>
                            <td><ReactSwitch title={mode == const_modebe? 'Aktueller Ausbau BET' :'Aktueller Ausbau'} layername='AktuellerAusbau'
                                                           checked={false}
                                                           applylayerchange={HandlyLayerChange}> Test</ReactSwitch></td>
                            {mode != const_modebe &&
                                <td><ReactSwitch title='Potientieller Ausbau' layername='PotentiellerAusbau'
                                                 checked={false}
                                                 applylayerchange={HandlyLayerChange}> Test</ReactSwitch></td>}
                        </tr>
                        </tbody>
                    </table>


                </div>
                <br/>
                <br/>
                {mode != const_modebe &&<div> Mehr Informationen finden Sie unter: <a className={ApplyClassName("hyper")}
                                                              href="https://kbb-bgld.rmdatacloud.com/">Burgenland
                    Networx Explorer</a></div>}
                <text className="quellangabe">Datenquelle: BMF und RTR-GmbH: <a className={ApplyClassName("hyper")}
                                                                                href="https://breitbandatlas.gv.at/47.8459/16.5183/Festnetz/">breitbandatlas.gv.at</a> (<a
                    className={ApplyClassName("hyper")}
                    href="https://creativecommons.org/licenses/by/3.0/at/">CC BY 3.0 AT</a>)
                </text>
            </div>
        </div>;
    }

    return (

        <div className={ApplyClassName("App")}>
            {mode != const_modebe && <h1 id="bbHeading">Breitband Burgenland</h1>}
            {content}
        </div>
    );

    function ApplyClassName(classname: string): string {
        if (mode === "BE")
            return classname + "be";
        else
            return classname;
    }

    function HandlyLayerChange(layername: string, checked: boolean
    ) {
        ApplyTheme(layername, checked);
    }

    function HandleGemeindeChange(newvalue: string) {
        let element: string;
        element = gemeindeoptions.find((element) => element.value == newvalue)?.label!;
        setAktGemeinde(element);
        ZoomExtent(gemeindeoptions.find((element) => element.value == newvalue)?.extent);
        SearchAnbieter(newvalue).then(function (data) {
            let anb: string[] = [];

            setAnbieter(data.map((x: any) => x.Anbieter));

        }).catch(function (err) {
            // Run this when promise was rejected via reject()
            console.log(err)
        });


        SearchFoerderprojekte(newvalue).then(function (data) {
            let foerder: Foerdernehmertype[] = [];
            data.forEach((element: any) => {
                let endestring: string;

                if (element.Projektende == "Abgeschlossen")
                    endestring = element.Projektende
                else
                    endestring = "bis " + element.Projektende

                if(mode==const_modebe)  {
                   if( element.FoerdernehmerIn=="BE Technology GmbH")
                       foerder.push(
                           {
                               name: element.Programm,
                               foerdernehmer: element.FoerdernehmerIn,
                               datum: endestring
                           });
                }
                else
                {
                    foerder.push(
                        {
                            name: element.Programm,
                            foerdernehmer: element.FoerdernehmerIn,
                            datum: endestring
                        });
                }


            });
            setFoerdernehmer(foerder);
            setLoading(false);
        }).catch(function (err) {
            // Run this when promise was rejected via reject()
            console.log(err)
        });
    }

}


export default App;
